import config from '../../config';

const SCHEDULE_PATH_NAME = '/shifts';

class HappinessSurveyController {
  constructor(Authentication, PersonaCollection, $rootScope, $timeout, $location) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection, $rootScope, $timeout, $location });
  }

  $onInit() {
    this.user = null;
    this.init();
  }

  async init() {
    if (!config.HAPPINESS_SURVEY_ENABLED) {
      return;
    }
    await this.Authentication.userLoaded;
    await this.PersonaCollection.personaCollectionLoaded;
    await this.$timeout(1000);

    this.user = this.Authentication.user;
    this.saveClientFlags = this.Authentication.saveClientFlags;
  }

  get locationsCount() {
    return this.PersonaCollection.locations.length;
  }

  get usersCount() {
    return this.PersonaCollection.users.length;
  }

  get onScheduleTab() {
    return this.$location.$$path == SCHEDULE_PATH_NAME;
  }

  get areShiftsPublished() {
    return this.Authentication.user.settings.clientFlags.shiftsHasBeenPublished || false;
  }

  onClose() {
    this.$rootScope.forceHappinessSurveyDisplay = false;
  }

  get forceDisplay() {
    return this.$rootScope.forceHappinessSurveyDisplay || false;
  }
}

export default {
  template: `
    <r-happiness-survey ng-if="!!ctrl.user && ctrl.usersCount"
      user="ctrl.user"
      locations-count="ctrl.locationsCount"
      users-count="ctrl.usersCount"
      save-client-flags="ctrl.saveClientFlags(flags)"
      on-schedule-tab="ctrl.onScheduleTab"
      are-shifts-published="ctrl.areShiftsPublished"
      force-display="ctrl.forceDisplay"
      on-close="ctrl.onClose()"
      >
    </r-happiness-survey>
    `,
  controller: HappinessSurveyController,
  controllerAs: 'ctrl',
};
